<template>
  <div class="accessory-item">
    <router-link
      :to="{
        name: 'accessories-item',
        params: { id: item.id },
      }"
      class="accessory-info"
    >
      <div class="image-wrapper">
        <img :src="item.image_urls[0]" />
      </div>
      <div class="info">
        <p class="title">{{ item.title }}</p>
        <div class="additional">
          <p>Цена: {{ formatPrice(item.price) }}₽</p>
          <p>Артикул: {{ item.vendor_code }}</p>
        </div>
      </div>
    </router-link>
    <div class="accessory-editable">
      <div class="editable-element">
        <label>Наличие</label>
        <multiselect
          v-model="item.availability_status"
          :options="availabilityStatuses"
          :class="{ 'form-error': errors[0]}"
          :show-labels="false"
          :searchable="false"
          :allowEmpty="false"
          @select="updateAccessory"
          track-by="id"
          label="title"
          placeholder="Выберите вариант"
        />
      </div>
      <div class="status-icons">
        <transition name="fade" mode="out-in">
          <div class="status-wrapper" v-if="!loading && !error && wasEdited" key="success">
            <span>Изменения сохранены</span>
            <img class="status-icon" src="@/assets/images/success-icon.svg" />
          </div>
          <div class="status-wrapper" v-else-if="!loading && error && wasEdited" key="failure">
            <span>Произошла ошибка</span>
            <img class="status-icon" src="@/assets/images/failure-icon.svg" />
          </div>
          <div class="status-wrapper loader-container" v-else-if="loading" key="loading">
            <loader class="status-icon" width="16px" height="16px" stroke="#4C4C4C" />
          </div>
        </transition>
      </div>
      <div class="tags">
        <span class="publish-status">{{ item.status.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout, clearTimeout } from 'timers';
export default {
  name: 'accessory-item',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      wasEdited: false,
      timeoutReference: null,
    };
  },

  computed: {
    ...mapGetters({
      soading: 'accessories/inlineLoading',
      error: 'accessories/inlineError',
      availabilityStatuses: 'accessories/availabilityStatuses',
    }),
  },

  methods: {
    ...mapActions({
      save: 'accessories/inlineSave',
    }),

    async updateAccessory(option) {
      clearTimeout(this.timeoutReference);
      this.wasEdited = true;
      this.loading = true;
      await this.save({ ...this.item, availability_status: option });
      this.loading = false;
      this.timeoutReference = setTimeout(() => (this.wasEdited = false), 4000);
    },

    formatPrice(value) {
      return (value / 1)
        .toFixed(2)
        .replace('.', ',')
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
  },
};
</script>

<style lang="scss" scoped>
.accessory-item {
  display: flex;
  flex-direction: column;
  margin: 14px 0;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);
  background: white;

  .accessory-editable {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row-reverse;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 12px;
    padding: 4px;

    .tags {
      display: flex;
      flex-wrap: wrap;

      .publish-status {
        padding: 4px 10px;
        margin: 2px 2px;
        background: #333;
        color: white;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        font-size: 12px;
        justify-self: flex-end;
        text-overflow: ellipsis;
      }
    }

    .editable-element {
      display: flex;
      align-items: center;

      label {
        white-space: pre;
        margin-right: 6px;
      }
    }

    .status-icons {
      display: flex;
      justify-content: flex-end;
      flex: 1;

      .loader-container {
        width: 16px;
        height: 16px;
        position: relative;
      }

      .status-wrapper {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0 6px;

        span {
          margin-right: 4px;
          text-align: right;
        }

        .status-icon {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  .accessory-info {
    display: flex;
    padding: 10px;
    text-decoration: none;

    &:hover {
      background: #eee;
      cursor: pointer;
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 120px;
        height: auto;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      flex: 1;
      text-align: right;

      .title {
        font-size: 19px;
        text-decoration: underline;
        margin-bottom: 6px;
      }

      .additional {
        font-size: 14px;
        text-decoration: underline;

        > * {
          margin-top: 8px;
        }
      }
    }
  }
}

.fade-enter-active {
  transition: all 0.4s;
}

.fade-leave-active {
  transition: all 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
.multiselect {
  min-height: 20px !important;

  &::v-deep {
    .multiselect__input,
    .multiselect__single {
      font-size: 12px;
      margin: 0;
      padding: 0;
    }

    .multiselect__tags {
      min-height: 20px;
      padding: 0 36px 0 8px;
    }

    .multiselect__option {
      font-size: 12px;
    }

    .multiselect__select {
      height: 20px;
      width: 36px;

      &::before {
        top: 10px;
      }
    }
  }
}
</style>

